import { prettyPrintDate } from "@prismicio/editor-support/Date"

import type { BillingPeriod } from "../../app/services/billing"

export function getCurrentBillingPeriod(
  billingPeriods: BillingPeriod[],
): BillingPeriod {
  const currentBillingPeriod = billingPeriods.at(-1)
  if (currentBillingPeriod === undefined)
    throw new Error("There should be at least one billing period.")
  return currentBillingPeriod
}

export function formatBillingPeriod(billingPeriod: BillingPeriod): string {
  const formatDate = (date: Date) => prettyPrintDate(date, { time: false })
  return `${formatDate(billingPeriod.startDate)} - ${formatDate(billingPeriod.endDate)}`
}
